import { render } from "./AccommodationHero.vue?vue&type=template&id=f77f1b92&scoped=true"
import script from "./AccommodationHero.vue?vue&type=script&lang=js"
export * from "./AccommodationHero.vue?vue&type=script&lang=js"

import "./AccommodationHero.vue?vue&type=style&index=0&id=f77f1b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77f1b92"]])

export default __exports__